.columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--mantine-spacing-xl);
}

.column {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
}

.columnTitle {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.addressLine {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-primary);
}

.empty {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-secondary);
  font-style: italic;
}

.services {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  margin-top: var(--mantine-spacing-sm);
}

.servicesTitle {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}
